<script>
import InputTag from 'vue-input-tag'
import baseInput from './baseInput'

export default {

    components: {[InputTag.name]:InputTag},

    mixins:[ baseInput ],

    name: 'custom-input-tag',

    props: {
        placeholder: String,
    },

    computed: {
        tags_length(){
            return this.tagsArray.length
        }
    },

    watch:{
        tags_length(value){
            this.internalValue = this.tagsArray
        }
    },

    data:()=>({
        tagsArray:[],
    }),

}
</script>

<template lang="html">
    <div class="input-tag-wrapper">
        <input-tag addTagOnBlur :placeholder="placeholder" :tags.sync="tagsArray"></input-tag>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/inputTag.vue